import {
  CreateReportTypeDocument,
  DeleteReportTypeDocument,
  ReportTypeGetByIdDocument,
  ReportTypeListDocument,
  ReportTypesPaginatedDocument,
  UpdateReportTypeDocument,
} from "api/generated";
import { getRequestInstance } from "api/services/utils";
import { RequestTypes } from "api/services/enums";
import { Optional, PartialNullable, ResourceEnum, ScopeEnum } from "config";

import {
  GetReportTypes,
  IReportTypeCreateVars,
  IReportTypeFilters,
  IReportTypeModel,
  IReportTypeUpdateVars,
  IReportTypesPaginatedResponse,
  ReportTypeCreateUpdateResponse,
} from "./types";

export async function getReportTypes(
  resource: ResourceEnum,
  scope: ScopeEnum
): Promise<GetReportTypes[]> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: ReportTypeListDocument,
      variables: {
        scope,
        resource,
      },
      fetchPolicy: "cache-first",
    });

    return res?.data?.reportTypeList ?? [];
  } catch (error) {
    throw error;
  }
}

export async function getReportTypesPaginated(
  variables: IReportTypeFilters
): Promise<IReportTypesPaginatedResponse> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: ReportTypesPaginatedDocument,
      variables,
      fetchPolicy: "cache-first",
    });

    return res?.data?.reportTypesPaginated;
  } catch (error) {
    throw error;
  }
}

export async function getReportType(
  reportTypeId: number
): Promise<PartialNullable<IReportTypeModel>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: ReportTypeGetByIdDocument,
      variables: { reportTypeId },
      fetchPolicy: "cache-first",
    });

    return res?.data?.reportTypeGetById;
  } catch (error) {
    throw error;
  }
}

export async function createReportType(
  variables: IReportTypeCreateVars
): Promise<Optional<ReportTypeCreateUpdateResponse>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: CreateReportTypeDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.reportTypeCreate;
  } catch (error) {
    throw error;
  }
}

export async function updateReportType(
  variables: IReportTypeUpdateVars
): Promise<Optional<ReportTypeCreateUpdateResponse>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: UpdateReportTypeDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.reportTypeUpdate;
  } catch (error) {
    throw error;
  }
}

export async function deleteReportType(reportTypeId: number): Promise<boolean> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: DeleteReportTypeDocument,
      variables: { reportTypeId },
      fetchPolicy: "no-cache",
    });

    return Boolean(res?.data?.reportTypeDelete);
  } catch (error) {
    throw error;
  }
}
